import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faqKeys = [
  { q: 'aboutAcademy.faq.q1', a: 'aboutAcademy.faq.a1' },
  { q: 'aboutAcademy.faq.q2', a: 'aboutAcademy.faq.a2' },
  { q: 'aboutAcademy.faq.q3', a: 'aboutAcademy.faq.a3' },
  { q: 'aboutAcademy.faq.q4', a: 'aboutAcademy.faq.a4' },
  { q: 'aboutAcademy.faq.q5', a: 'aboutAcademy.faq.a5' },
];

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqKeys.map((faq) => ({
      '@type': 'Question',
      name: t(faq.q),
      acceptedAnswer: {
        '@type': 'Answer',
        text: t(faq.a),
      },
    })),
  };

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData) }}
      />

      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          {String(t('aboutAcademy.faq.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('aboutAcademy.faq.title')}
          </h2>
          {String(t('aboutAcademy.faq.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="space-y-3">
          {faqKeys.map((faq, idx) => (
            <div key={faq.q} className="border border-background-200/60 bg-background-50">
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <span className="text-[16px] text-foreground-800 tracking-[0.04em] font-medium pr-4">
                  {t(faq.q)}
                </span>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-accent-500 text-sm transition-transform duration-300 ${
                      openIndex === idx ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-[1200px]' : 'max-h-0'
                }`}
              >
                {String(t(faq.a)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="px-5 pb-5 text-[16px] text-foreground-600 tracking-[0.04em] leading-[1.95]">{__s}</p>))}
              </div>
            </div>
          ))}
        </div>

        {String(t('aboutAcademy.faq.footer')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-center text-[14px] text-foreground-400 tracking-[0.04em] mt-8">{__s}</p>))}
      </div>
    </section>
  );
}
